export var GLOBAL = {    
    //url: 'http://localhost:4201', //local
    url: 'https://api.carmen.com.ar' //docker    
}